module.exports = __webpack_public_path__ + "img/exclamation.5ae205ea.png";